/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 6/12/2023
 */

import { Check } from '@mui/icons-material'
import { Button, Dialog, DialogContent, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router'
import styles from "./CheckoutSuccess.module.css"

const CheckoutSuccess = ({ open }) => {

    const navigate = useNavigate()

    return (
        <Dialog
            fullWidth={true}
            maxWidth="xs"
            open={open}
            aria-labelledby="success-dialog"
        >
            <DialogContent className={styles.container}>
                <Typography className={styles.title}>Thank You!</Typography>
                <Check className={styles.icon} />
                <Typography className={styles.description}>Your Request was submitted Successfully!</Typography>
                <Button className={styles.button} variant='contained' onClick={() => navigate('/')}>Ok</Button>
            </DialogContent>
        </Dialog>
    )
}

export default CheckoutSuccess